import { AccountsResponseV2, CheckoutResponse, CheckoutSession, SessionCookieKeyNames } from '@pff-consumer/schema'
import { deleteSessionCookie, getSessionCookie, setSessionCookie } from './session-cookie'

const clearCheckoutSessionData = () => {
  deleteSessionCookie(SessionCookieKeyNames.CHECKOUT_SESSION)
}

// Gets a sesion cookie from approved list of keys
export const getCheckoutSessionData = (): CheckoutSession | undefined => {
  const data = getSessionCookie<CheckoutSession>(SessionCookieKeyNames.CHECKOUT_SESSION)

  // Lets clear the cookie to prevent refreshes or subsequent visits to the /complete route
  clearCheckoutSessionData()

  return data
}

export const setCheckoutSessionData = (value: CheckoutSession) =>
  setSessionCookie<CheckoutSession>(SessionCookieKeyNames.CHECKOUT_SESSION, value)

/**
 * Convert the response from the /checkout call to how we want it for the complete page.
 */
export const transformCheckoutResponseToCheckoutSession = (
  data: CheckoutResponse | AccountsResponseV2,
  email: string
): CheckoutSession => {
  // CheckoutResponseNewUser
  if ('password' in data && data.password != null && 'token' in data && 'access_token' in data.token) {
    return {
      accessToken: data.token.access_token,
      email,
      isExistingUser: false,
      password: data.password,
      uid: data.uid,
    }
  }

  // CheckoutResponseExistingUser
  return {
    isExistingUser: true,
    email,
    uid: data.uid,
  }
}

export const setSessionId = (value: string | null) =>
  setSessionCookie<string | null>(SessionCookieKeyNames.SESSION_ID, value)

export const getSessionId = (): string | undefined => getSessionCookie<string>(SessionCookieKeyNames.SESSION_ID)
